import { render, staticRenderFns } from "./document-tracking(new).vue?vue&type=template&id=0a200860&"
import script from "./document-tracking(new).vue?vue&type=script&lang=js&"
export * from "./document-tracking(new).vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports